import { AxiosError } from 'axios'
import { ENDPOINTS } from 'constants/endpoints'
import apiInstance from 'services/api/instance'

import { handleErrorMessage } from '../errors'

export const getAll = async (): Promise<MenuApiResponse[]> => {
  try {
    const getAllResponse = await apiInstance.get<MenuApiResponse[]>(
      ENDPOINTS.MENUS.GET_ALL,
    )

    return getAllResponse.data
  } catch (getAllError) {
    const axiosError = getAllError as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const get = async (id: string): Promise<MenuApiResponse> => {
  try {
    const getResponse = await apiInstance.get<MenuApiResponse>(
      ENDPOINTS.MENUS.GET(id),
    )

    return getResponse.data
  } catch (getError) {
    const axiosError = getError as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const create = async (
  menu: MenusApiRequest,
): Promise<MenuApiResponse> => {
  try {
    const creationResponse = await apiInstance.post<MenuApiResponse>(
      ENDPOINTS.MENUS.CREATE,
      menu,
    )

    return creationResponse.data
  } catch (creationError) {
    const axiosError = creationError as AxiosError

    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const update = async ({
  id,
  menu,
}: {
  menu: MenusApiRequest
  id: string
}): Promise<MenuApiResponse> => {
  try {
    const updateResponse = await apiInstance.put<MenuApiResponse>(
      ENDPOINTS.MENUS.UPDATE(id),
      menu,
    )

    return updateResponse.data
  } catch (updateError) {
    const axiosError = updateError as AxiosError

    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const remove = async (id: string) => {
  try {
    const deleteResponse = await apiInstance.delete(ENDPOINTS.MENUS.DELETE(id))

    return deleteResponse.data
  } catch (deleteError) {
    const axiosError = deleteError as AxiosError

    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}
